// import React from "react";
// import { motion } from "framer-motion";
// import { FaMobileAlt, FaCarSide, FaCreditCard } from "react-icons/fa";
// import Button from "../ui/Button";

// export default function HowItWorks() {
//   const steps = [
//     {
//       icon: <FaMobileAlt />,
//       title: "Book",
//       description: "Open the app and choose your ride type",
//       color: "linear-gradient(135deg, #E63946, #dc2626)",
//     },
//     {
//       icon: <FaCarSide />,
//       title: "Ride",
//       description: "Get matched with a nearby driver instantly",
//       color: "linear-gradient(135deg, #FFC300, #f97316)",
//     },
//     {
//       icon: <FaCreditCard />,
//       title: "Pay",
//       description: "Pay safely via cash, UPI, or card",
//       color: "linear-gradient(135deg, #22c55e, #14b8a6)",
//     },
//   ];

//   const width = typeof window !== "undefined" ? window.innerWidth : 1024;

//   // Animation variants
//   const fadeUp = {
//     hidden: { opacity: 0, y: 50 },
//     show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
//   };

//   return (
//     <section
//       style={{
//         padding: width < 768 ? "60px 16px" : "96px 20px",
//         background: "white",
//       }}
//     >
//       <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//         {/* Header */}
//         <motion.div
//           style={{ textAlign: "center", marginBottom: width < 768 ? "40px" : "80px" }}
//           initial={{ opacity: 0, y: 50 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, ease: "easeOut" }}
//           viewport={{ once: true }}
//         >
//           <span
//             style={{
//               background: "linear-gradient(to right, #E63946, #FFC300)",
//               color: "white",
//               padding: width < 768 ? "6px 18px" : "8px 24px",
//               borderRadius: "50px",
//               fontSize: width < 768 ? "18px" : "20px",
//               fontWeight: "600",
//             }}
//           >
//             How It Works
//           </span>
//           <h2
//             style={{
//               fontSize: width < 768 ? "clamp(24px, 6vw, 36px)" : "clamp(32px, 6vw, 48px)",
//               fontWeight: "bold",
//               color: "#1C1C1C",
//               margin: "24px 0 16px",
//             }}
//           >
//             Getting Started is{" "}
//             <span
//               style={{
//                 background: "linear-gradient(to right, #E63946, #FFC300)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//               }}
//             >
//               Easy
//             </span>
//           </h2>
//         </motion.div>

//         {/* Steps Grid */}
//         <div
//           style={{
//             display: "flex",
//             flexDirection: width < 1024 ? "column" : "row",
//             gap: width < 768 ? "20px" : "35px",
//             justifyContent: width >= 1024 ? "space-between" : "center",
//             alignItems: "stretch",
//           }}
//         >
//           {steps.map((step, index) => (
//             <motion.div
//               key={index}
//               variants={fadeUp}
//               initial="hidden"
//               whileInView="show"
//               viewport={{ once: true, amount: 0.2 }}
//               transition={{ delay: index * 0.2 }}
//               whileHover={{
//                 scale: 1.05,
//                 rotate: 1,
//                 transition: { duration: 0.3 },
//               }}
//               style={{
//                 flex: width >= 1024 ? "1" : "unset",
//                 display: "flex",
//                 flexDirection: "column",
//                 height: "100%",
//                 position: "relative",
//               }}
//             >
//               {/* Number Circle */}
//               <motion.div
//                 style={{
//                   position: "absolute",
//                   top: "-16px",
//                   left: "-16px",
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "50%",
//                   background: "linear-gradient(to right, #E63946, #FFC300)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "white",
//                   fontSize: "20px",
//                   fontWeight: "bold",
//                   boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
//                   zIndex: 2,
//                 }}
//                 whileHover={{ rotate: 360, scale: 1.1, transition: { duration: 0.6 } }}
//               >
//                 {index + 1}
//               </motion.div>

//               {/* Card */}
//               <motion.div
//                 style={{
//                   background: "white",
//                   borderRadius: "24px",
//                   padding: width < 768 ? "24px" : "40px",
//                   boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//                   transition: "all 0.3s ease",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   textAlign: "center",
//                   height: "100%",
//                   position: "relative",
//                   zIndex: 1,
//                 }}
//                 whileHover={{
//                   y: -10,
//                   boxShadow: "0 25px 45px rgba(0,0,0,0.15)",
//                   transition: { duration: 0.3 },
//                 }}
//               >
//                 {/* Step Icon */}
//                 <motion.div
//                   style={{
//                     width: width < 768 ? "64px" : "80px",
//                     height: width < 768 ? "64px" : "80px",
//                     background: step.color,
//                     borderRadius: "16px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: width < 768 ? "28px" : "40px",
//                     marginBottom: "12px",
//                     color: "white",
//                     boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
//                   }}
//                   whileHover={{
//                     scale: 1.15,
//                     rotate: -8,
//                     transition: { type: "spring", stiffness: 200 },
//                   }}
//                 >
//                   {step.icon}
//                 </motion.div>

//                 {/* Title */}
//                 <h3
//                   style={{
//                     fontSize: width < 768 ? "20px" : "24px",
//                     fontWeight: "bold",
//                     color: "#1C1C1C",
//                     marginBottom: "8px",
//                   }}
//                 >
//                   {step.title}
//                 </h3>

//                 {/* Description */}
//                 <p
//                   style={{
//                     fontSize: width < 768 ? "14px" : "18px",
//                     color: "#6C757D",
//                     minHeight: "45px",
//                   }}
//                 >
//                   {step.description}
//                 </p>
//               </motion.div>
//             </motion.div>
//           ))}
//         </div>

//         {/* CTA Button */}
//         <motion.div
//           style={{ textAlign: "center", marginTop: width < 768 ? "40px" : "64px" }}
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.2, duration: 0.6 }}
//           viewport={{ once: true }}
//         >
//           <Button>Start Your Journey Now</Button>
//         </motion.div>
//       </div>
//     </section>
//   );
// }





























































import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaMobileAlt, FaCarSide, FaCreditCard } from "react-icons/fa";
import Button from "../ui/Button";

export default function HowItWorks() {
  const [width, setWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = width < 768;
  const isTablet = width >= 768 && width < 1024;

  const steps = [
    {
      icon: <FaMobileAlt />,
      title: "Book",
      description: "Open the app and choose your ride type",
      color: "linear-gradient(135deg, #E63946, #dc2626)",
    },
    {
      icon: <FaCarSide />,
      title: "Ride",
      description: "Get matched with a nearby driver instantly",
      color: "linear-gradient(135deg, #FFC300, #f97316)",
    },
    {
      icon: <FaCreditCard />,
      title: "Pay",
      description: "Pay safely via cash, UPI, or card",
      color: "linear-gradient(135deg, #22c55e, #14b8a6)",
    },
  ];

  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  };

  return (
    <section
      style={{
        padding: isMobile ? "60px 16px" : "96px 20px",
        background: "white",
      }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
        {/* Header */}
        <motion.div
          style={{ textAlign: "center", marginBottom: isMobile ? "40px" : "80px" }}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <span
            style={{
              background: "linear-gradient(to right, #E63946, #FFC300)",
              color: "white",
              padding: isMobile ? "6px 18px" : "8px 24px",
              borderRadius: "50px",
              fontSize: isMobile ? "18px" : "20px",
              fontWeight: "600",
            }}
          >
            How It Works
          </span>
          <h2
            style={{
              fontSize: isMobile ? "clamp(24px,6vw,36px)" : "clamp(32px,6vw,48px)",
              fontWeight: "bold",
              color: "#1C1C1C",
              margin: "24px 0 16px",
            }}
          >
            Getting Started is{" "}
            <span
              style={{
                background: "linear-gradient(to right, #E63946, #FFC300)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Easy
            </span>
          </h2>
        </motion.div>

        {/* Steps Grid */}
        <div
          style={{
            display: "flex",
            flexDirection: width < 1024 ? "column" : "row",
            gap: isMobile ? "20px" : "35px",
            justifyContent: width >= 1024 ? "space-between" : "center",
            alignItems: "stretch",
          }}
        >
          {steps.map((step, index) => (
            <motion.div
              key={index}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: index * 0.2 }}
              whileHover={{
                scale: 1.05,
                rotate: 1,
                transition: { duration: 0.3 },
              }}
              style={{
                flex: width >= 1024 ? "1" : "unset",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                position: "relative",
              }}
            >
              {/* Number Circle */}
              <motion.div
                style={{
                  position: "absolute",
                  top: "-16px",
                  left: "-16px",
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  background: "linear-gradient(to right, #E63946, #FFC300)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontSize: "20px",
                  fontWeight: "bold",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                  zIndex: 2,
                }}
                whileHover={{ rotate: 360, scale: 1.1, transition: { duration: 0.6 } }}
              >
                {index + 1}
              </motion.div>

              {/* Card */}
              <motion.div
                style={{
                  background: "white",
                  borderRadius: "24px",
                  padding: isMobile ? "24px" : "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  height: "100%",
                  position: "relative",
                  zIndex: 1,
                  transition: "all 0.3s ease",
                }}
                whileHover={{
                  y: -10,
                  boxShadow: "0 25px 45px rgba(0,0,0,0.15)",
                  transition: { duration: 0.3 },
                }}
              >
                {/* Step Icon */}
                <motion.div
                  style={{
                    width: isMobile ? "64px" : "80px",
                    height: isMobile ? "64px" : "80px",
                    background: step.color,
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: isMobile ? "28px" : "40px",
                    marginBottom: "12px",
                    color: "white",
                    boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
                  }}
                  whileHover={{
                    scale: 1.15,
                    rotate: -8,
                    transition: { type: "spring", stiffness: 200 },
                  }}
                >
                  {step.icon}
                </motion.div>

                {/* Title */}
                <h3
                  style={{
                    fontSize: isMobile ? "20px" : "24px",
                    fontWeight: "bold",
                    color: "#1C1C1C",
                    marginBottom: "8px",
                  }}
                >
                  {step.title}
                </h3>

                {/* Description */}
                <p
                  style={{
                    fontSize: isMobile ? "14px" : "18px",
                    color: "#6C757D",
                    minHeight: "45px",
                  }}
                >
                  {step.description}
                </p>
              </motion.div>
            </motion.div>
          ))}
        </div>

        {/* CTA Button */}
        <motion.div
          style={{ textAlign: "center", marginTop: isMobile ? "40px" : "64px" }}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Button>Start Your Journey Now</Button>
        </motion.div>
      </div>
    </section>
  );
}
